import { TIPO_INSPECAO } from "@/constants/TIPO_INSPECAO";
import { IEstabelecimento } from "@/interfaces/IEstabelecimento";
import { api } from "@/services/api";
import { estabelecimentoAction } from "@/store/actions/estabelecimento";
import { getEstabelecimentosSynced } from "@/store/reducers/estabelecimento";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useEstabelecimento = () => {
  const { user } = useAuth();
  const listaEstabelecimentos = useSelector(getEstabelecimentosSynced);
  const appDispatch = useDispatch();
  const { sync } = estabelecimentoAction;

  const estabelecimentoOptions = listaEstabelecimentos.map((e) => ({
    label: `${e.numeroInspecao} - ${TIPO_INSPECAO[e.tipoInspecao]} - ${e.nome}`,
    value: e.id,
  }));

  const getEstabelecimentosApi = async () => {
    const { data } = await api.get<IEstabelecimento[]>(
      `/estabelecimentos/todos`,
      {
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      }
    );
    return data;
  };

  const sincronizarEstabelecimentos = (
    estabelecimentos: IEstabelecimento[]
  ) => {
    appDispatch(sync(estabelecimentos));
  };

  const getEstabelecimentoById = (id: number) => {
    return listaEstabelecimentos.find(
      (estabelecimento) => estabelecimento.id === id
    );
  };

  return {
    getEstabelecimentosApi,
    listaEstabelecimentos,
    sincronizarEstabelecimentos,
    estabelecimentoOptions,
    getEstabelecimentoById,
  };
};
